var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useEffect, useMemo, useState } from "react";
import parse from "html-react-parser";
import styledComponents from "styled-components";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Flex } from "../Flex";
import { FLEX_ROW, PRICE_LINE_TOTAL, COUNT_OF_PARTICIPANTS, PRICE_BREAKUP, PRICE_ROW, PRICE_TOTAL, SUB_PRICE, EXTRA_PRICE, PRICE_TITLE } from "../../classConstants";
import { currency, getClassName, useMediaQuery } from "../../helpers";
import { getBookManager } from "../../models/BookModel";
import get from "lodash/get";
import { getBookDataPaginatedResponse } from "../../store/actions/response.actions";
import { LoaderState } from "../../store/actions/loader.actions";
import { API_METHODS_ENUM } from "../../httpService";
import { Button } from "../Form";
import { SvgIcon } from "../../icons";
import { getBookingFormManager } from "../../FormManager/BookingFormManager";
import { getBookDataResponseManager, isBookDataUpdated } from "../../models/BookModel/helpers";
var priceSummaryFactory = function () {
    var PriceBreakupComponent = function (props) {
        var t = useTranslation().t;
        var allPrices = props.allPrices, className = props.className, isSingleColumn = props.isSingleColumn;
        var isMobile = useMediaQuery('(max-width: 786px)');
        var _a = useState(isMobile), isCollapsed = _a[0], setIsCollapsed = _a[1];
        var setCollapsed = useCallback(function (isCollapsed) { return isMobile && setIsCollapsed(isCollapsed); }, [isMobile]);
        var sumTotalFormatted = useMemo(function () {
            var total = allPrices.reduce(function (sumTotal, price) {
                return sumTotal + get(price, "sumTotal", 0);
            }, 0);
            return currency(total).format();
        }, [JSON.stringify(allPrices)]);
        useEffect(function () { setCollapsed(isMobile || isSingleColumn); }, [isMobile, isSingleColumn, setCollapsed]);
        var Wrap = function (props) {
            var summaryProps = __assign(__assign({}, props), { isMobile: isMobile,
                isSingleColumn: isSingleColumn, className: getClassName(className, PRICE_BREAKUP) });
            return React.createElement(PriceSummaryWrapper, __assign({}, summaryProps));
        };
        // const NoPriceSelected = () => {
        //     return <Wrap><SummaryHeader>{t("price_summary.no_price_selected")}</SummaryHeader></Wrap>;
        // }
        var PriceRow = function (_a) {
            var _b;
            var _c = _a.priceModel, sumTotalFormatted = _c.sumTotalFormatted, title = _c.title, quantity = _c.quantity, priceModel = __rest(_c, ["sumTotalFormatted", "title", "quantity"]), _d = _a.hasPrice, hasPrice = _d === void 0 ? true : _d, _e = _a.isSubPrice, isSubPrice = _e === void 0 ? false : _e, _f = _a.isExtraPrice, isExtraPrice = _f === void 0 ? false : _f, _g = _a.className, className = _g === void 0 ? "" : _g;
            var countOfParticipants = quantity ? parse("&times; " + quantity) : '';
            return React.createElement(PriceRowComponent, { forwardedAs: "dl", className: getClassName(priceModel.className, className, PRICE_ROW) },
                React.createElement("dt", { className: getClassName((_b = {}, _b[SUB_PRICE] = isSubPrice, _b[EXTRA_PRICE] = isExtraPrice, _b)) },
                    React.createElement("span", { className: PRICE_TITLE }, parse(title)),
                    React.createElement("span", { className: COUNT_OF_PARTICIPANTS }, countOfParticipants)),
                hasPrice && React.createElement("dd", { className: PRICE_LINE_TOTAL }, sumTotalFormatted));
        };
        var SummaryToggle = function () {
            if (!isMobile)
                return null;
            var type = isCollapsed ? "arrowup" : "arrow";
            var buttonProps = {
                variant: "clear",
                icon: React.createElement(SvgIcon, { type: type }),
                type: "button",
                onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    setCollapsed(!isCollapsed);
                }
            };
            return React.createElement(SummaryToggleButton, __assign({}, buttonProps));
        };
        var getCollapsableTitle = function (showTotal) {
            var price = showTotal === true ? React.createElement("span", { className: PRICE_LINE_TOTAL }, sumTotalFormatted) : null;
            var titleKey = isCollapsed ? "price_summary.price_breakup_collapsed" : "price_summary.price_breakup";
            return (React.createElement(SummaryTitle, { onClick: function () { return setCollapsed(!isCollapsed); }, className: getClassName({ "ws-collapsed": isCollapsed }) },
                React.createElement(SummaryHeader, null, t(titleKey)),
                price,
                React.createElement(SummaryToggle, null)));
        };
        var PriceBreakupDefinition = function () {
            if (isCollapsed)
                return getCollapsableTitle(true);
            var hasPrice = allPrices.some(function (_a) {
                var sumTotal = _a.sumTotal;
                return sumTotal;
            });
            var priceList = allPrices.map(function (item, i) {
                return React.createElement(PriceRow, { key: i, priceModel: item, hasPrice: hasPrice });
            });
            var total = { sumTotalFormatted: sumTotalFormatted, title: t('price_summary.total') };
            if (hasPrice) {
                priceList.push(React.createElement(PriceRow, { key: "total-amount", priceModel: total, className: PRICE_TOTAL }));
            }
            return (React.createElement(React.Fragment, null,
                getCollapsableTitle(false),
                priceList));
        };
        if (props.isLoading)
            return null;
        if (allPrices.length === 0) {
            return null;
            // return isMobile ? null : <NoPriceSelected />;
        }
        return React.createElement(Wrap, null,
            React.createElement(PriceBreakupDefinition, null));
    };
    var mapStateToProps = function (state, _a) {
        var name = _a.name, formName = _a.formName;
        var forms = get(state.formReducer, "forms", {});
        var loaderState = new LoaderState(state.loaderReducer, { keys: [API_METHODS_ENUM.GET_INITIAL_ENTITIES, API_METHODS_ENUM.GET_BOOK_ENTITIES] });
        var bookData = getBookDataPaginatedResponse(state.responseReducer);
        return {
            bookData: bookData,
            isLoading: !bookData.length && loaderState.isLoading() && !loaderState.hasLoaded(),
            form: forms[formName] || forms[name] || null
        };
    };
    var mergeProps = function (stateProps, dispatchProps, ownProps) {
        var bookData = stateProps.bookData, form = stateProps.form;
        var mergedProps = __assign(__assign({}, ownProps), { allPrices: [], isLoading: stateProps.isLoading });
        var bookDataRM = getBookDataResponseManager(bookData);
        if (bookDataRM) {
            var entities = bookDataRM.entities;
            var bookManager = getBookManager(entities);
            var breakup = getBookingFormManager({ modelManager: bookManager, form: form || {} }).getPriceBreakup();
            mergedProps.allPrices = breakup;
        }
        return mergedProps;
    };
    return connect(mapStateToProps, null, mergeProps, isBookDataUpdated("bookData"))(PriceBreakupComponent);
};
var PriceSummaryWrapper = styledComponents(function (_a) {
    var isSingleColumn = _a.isSingleColumn, isMobile = _a.isMobile, props = __rest(_a, ["isSingleColumn", "isMobile"]);
    return React.createElement(Flex, __assign({ isInline: false }, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border: var(--ws-price-summary-border);\n    border-radius: var(--ws-price-summary-border-radius);\n    padding: 1rem;\n\n    position: sticky;\n    background: var(--ws-price-summary-bg);\n    + * { margin-top: 1em !important };\n\n    ", "\n"], ["\n    border: var(--ws-price-summary-border);\n    border-radius: var(--ws-price-summary-border-radius);\n    padding: 1rem;\n\n    position: sticky;\n    background: var(--ws-price-summary-bg);\n    + * { margin-top: 1em !important };\n\n    ",
    "\n"])), function (_a) {
    var isSingleColumn = _a.isSingleColumn, isMobile = _a.isMobile;
    return isSingleColumn || isMobile ? "\n            bottom: var(--ws-price-summary-offset-bottom, 0);\n        " : "\n            top: var(--ws-price-summary-offset-top, 1em);\n        ";
});
var SummaryToggleButton = styledComponents(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-left: 1em !important;\n    width: 1em;\n    padding: 0;\n"], ["\n    margin-left: 1em !important;\n    width: 1em;\n    padding: 0;\n"])));
var SummaryHeader = styledComponents.h3(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0;\n    margin-right: auto;\n"], ["\n    margin: 0;\n    margin-right: auto;\n"])));
var SummaryTitle = styledComponents(Flex)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 100%;\n    margin: 0 0 1em;\n    &.ws-collapsed {\n        margin-bottom: 0;\n    }\n"], ["\n    width: 100%;\n    margin: 0 0 1em;\n    &.ws-collapsed {\n        margin-bottom: 0;\n    }\n"])));
var PriceRowComponent = styledComponents(Flex)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    &.", " {\n        align-items: flex-start;\n    }\n"], ["\n    &.", " {\n        align-items: flex-start;\n    }\n"])), FLEX_ROW);
export var PriceBreakup = styledComponents(priceSummaryFactory())(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    flex-wrap: nowrap !important;\n    max-height: var(--ws-price-summary-max-height, 25vh);\n    overflow: auto;\n\n    > * {\n        flex-shrink: 0;\n    }\n\n    dl {\n        margin: 0;\n    }\n\n    dl + dl {\n        margin-top: 5px;\n    }\n    dl dt {\n        flex: 1;\n        margin-right: 1rem;\n        display: flex;\n    }\n    dl dd {\n        margin: 0;\n        min-width: 100px;\n        text-align: right;\n    }\n    .", " {\n        margin-left: auto\n    }\n    .", " {\n        font-weight: bold;\n        white-space: nowrap;\n    }\n    .", " {\n        margin-right: 1em;\n    }\n    .", " {\n        margin-left: auto;\n        white-space: nowrap;\n    }\n    &:last-child {\n        margin-top: 1em;\n    }\n"], ["\n    flex-wrap: nowrap !important;\n    max-height: var(--ws-price-summary-max-height, 25vh);\n    overflow: auto;\n\n    > * {\n        flex-shrink: 0;\n    }\n\n    dl {\n        margin: 0;\n    }\n\n    dl + dl {\n        margin-top: 5px;\n    }\n    dl dt {\n        flex: 1;\n        margin-right: 1rem;\n        display: flex;\n    }\n    dl dd {\n        margin: 0;\n        min-width: 100px;\n        text-align: right;\n    }\n    .", " {\n        margin-left: auto\n    }\n    .", " {\n        font-weight: bold;\n        white-space: nowrap;\n    }\n    .", " {\n        margin-right: 1em;\n    }\n    .", " {\n        margin-left: auto;\n        white-space: nowrap;\n    }\n    &:last-child {\n        margin-top: 1em;\n    }\n"])), PRICE_LINE_TOTAL, PRICE_TOTAL, PRICE_TITLE, COUNT_OF_PARTICIPANTS);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
